import React from 'react';

export default function DiamondIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <path
        d="M11.669 21.5458C11.1565 21.5436 10.6496 21.4335 10.1823 21.2228C9.7151 21.0121 9.29736 20.7054 8.95635 20.3227L2.22353 12.9228C1.77377 12.3846 1.47589 11.736 1.36179 11.044C1.24769 10.352 1.32141 9.64199 1.57459 8.98792L4.08502 5.28602V5.27835C4.44711 4.63041 4.93774 4.06349 5.52572 3.61048C6.09268 3.2327 6.765 3.04482 7.44569 3.07369H15.8761C16.5647 3.04671 17.2436 3.23913 17.8152 3.6239C18.3966 4.06809 18.8796 4.62809 19.2329 5.26876L21.7328 8.97834C21.9871 9.63173 22.0612 10.3415 21.9485 11.0335C21.8358 11.7254 21.54 12.3742 21.0915 12.9132L14.3693 20.3266C14.0319 20.7103 13.6166 21.0183 13.151 21.2286C12.6853 21.4388 12.18 21.5466 11.669 21.5458ZM7.45527 4.14439C7.02603 4.12612 6.59982 4.22906 6.22641 4.44154C5.85301 4.65402 5.54714 4.9671 5.34359 5.34545L5.33784 5.35407L5.29087 5.4183C5.24572 5.48013 5.18597 5.56017 5.12217 5.64164L2.58298 9.38668L2.57531 9.40393C2.40635 9.86698 2.35929 10.3656 2.43728 10.8523C2.51528 11.339 2.71584 11.7976 3.02104 12.1847L9.75482 19.5875C9.99335 19.8606 10.2874 20.0798 10.6175 20.2297C10.9476 20.3797 11.3064 20.4579 11.669 20.4579C12.0316 20.4579 12.3895 20.3797 12.7196 20.2297C13.0497 20.0798 13.3447 19.8606 13.5833 19.5875L20.3055 12.176C20.6173 11.7915 20.8226 11.3316 20.9008 10.8427C20.979 10.3538 20.9275 9.85318 20.7513 9.39051L20.7446 9.37517L18.2312 5.64451L18.2245 5.63589C18.1961 5.59859 18.1686 5.55914 18.1421 5.52086L18.1248 5.49881L18.0721 5.42692C17.8634 5.03118 17.5493 4.70156 17.1634 4.47509C16.7776 4.24862 16.3358 4.13462 15.8886 4.14535L7.45527 4.14439Z"
        fill={props.fill ?? '#DC4405'}
      />
      <path
        d="M5.71136 11.0901L4.85938 10.5994L8.78558 3.72852L9.73965 3.97587L5.71136 11.0901Z"
        fill={props.fill ?? '#DC4405'}
      />
      <path
        d="M17.6201 11.0901L13.5898 4.00039L14.5459 3.73242L18.4721 10.6033L17.6201 11.0901Z"
        fill={props.fill ?? '#DC4405'}
      />
      <path
        d="M20.9786 11.337H2.3291V10.3555H20.9786V11.337Z"
        fill={props.fill ?? '#DC4405'}
      />
      <path
        d="M10.7375 20.8822L5.12402 11.0667L6.00153 10.6279L11.615 20.4434L10.7375 20.8822Z"
        fill={props.fill ?? '#DC4405'}
      />
      <path
        d="M12.5972 20.8808L11.7197 20.442L17.2439 10.6147L18.1214 11.0535L12.5972 20.8808Z"
        fill={props.fill ?? '#DC4405'}
      />
    </svg>
  );
}
